import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { clearFBChecklistTemplate } from 'redux/modules/reportFacebookChecklist';
import Gauge from 'react-radial-gauge';
import { Spinner } from 'components';
import * as styles from './FacebookChecklistPreview.scss';
var FacebookChecklistPreview = (_dec = connect(function (state) {
  return {
    reports: state.reporting.reports,
    selectedClient: state.reportBuilder.selectedClient
  };
}, {
  clearFBChecklistTemplate: clearFBChecklistTemplate
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(FacebookChecklistPreview, _Component);

  var _super = _createSuper(FacebookChecklistPreview);

  function FacebookChecklistPreview() {
    var _this;

    _classCallCheck(this, FacebookChecklistPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getScoreDescription", function (score) {
      var scoreText = 'Needs Improvement';

      if (score === 100) {
        scoreText = 'Perfect';
      } else if (score > 90) {
        scoreText = 'Exceptional';
      } else if (score > 80) {
        scoreText = 'Very Good';
      } else if (score > 70) {
        scoreText = 'Good';
      } else if (score > 60) {
        scoreText = 'Average';
      }

      return scoreText;
    });

    _defineProperty(_assertThisInitialized(_this), "formatPostiveNegative", function (number) {
      return number < 0 ? number : "+ ".concat(number);
    });

    return _this;
  }

  _createClass(FacebookChecklistPreview, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearFBChecklistTemplate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          template = _this$props.template,
          reports = _this$props.reports,
          selectedClient = _this$props.selectedClient;
      var checklistReports = reports && selectedClient && reports[selectedClient.id] && !!reports[selectedClient.id].length ? reports[selectedClient.id].filter(function (r) {
        return r.reportType === 'facebookChecklist';
      }) : [];
      var score = template && !!template.sections.length ? template.sections.map(function (section) {
        return section.score;
      }).reduce(function (acc, currentValue) {
        return acc + currentValue;
      }) : 0;
      score = Math.round(score);
      var gaugeOptions = {
        currentValue: score,
        dialWidth: 10,
        dialColor: '#BCD3AB',
        tickColor: '#3F7410',
        progressWidth: 10,
        progressColor: '#3F7410',
        needleSharp: true,
        needleWidth: 10
      };
      var recentImprovements = template ? template.sections.filter(function (section) {
        return section.rawUpdatedAt;
      }).sort(function (a, b) {
        return new Date(b.rawUpdatedAt).getTime() - new Date(a.rawUpdatedAt).getTime();
      }).slice(0, 4) : [];
      var missing = template ? template.sections.filter(function (section) {
        return !section.data;
      }).filter(function (section) {
        return section.value > 2;
      }) : [];
      var missingFormatted = missing.slice(0, 4).map(function (m) {
        return m.label;
      });

      if (missing.length > 4) {
        missingFormatted = missingFormatted.slice(0, 3);
        missingFormatted.push("".concat(missing.length - 3, " other items"));
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 16
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.topSection
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header,
        style: {
          marginTop: 36
        }
      }, "Your Score Overview"), /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionContent
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '0 0 46%',
          marginRight: '4%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionGraph
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 auto'
        }
      }, /*#__PURE__*/React.createElement(Gauge, gaugeOptions))), /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionScore
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.scoreWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.score
      }, Math.round(score)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: styles.scoreDescription
      }, this.getScoreDescription(Math.round(score)))), !!checklistReports.length && /*#__PURE__*/React.createElement("div", {
        className: styles.scoreChangeWrap
      }, /*#__PURE__*/React.createElement("span", null, template.lastReportScore, /*#__PURE__*/React.createElement("br", null), template.lastReportDate), /*#__PURE__*/React.createElement("span", null, this.formatPostiveNegative(Math.round(score) - parseInt(template.lastReportScore, 10)), /*#__PURE__*/React.createElement("br", null), "Change")))), /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionDetails
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionDetailCol
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionDetailHeader
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.arrowUp
      }, "\u2191"), "Recent Improvements"), /*#__PURE__*/React.createElement("ul", {
        className: styles.sectionList
      }, recentImprovements.map(function (item) {
        return /*#__PURE__*/React.createElement("li", {
          className: styles.plusItem
        }, item.label);
      }))), !!missingFormatted.length && /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionDetailCol
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.topSectionDetailHeader
      }, ' ', /*#__PURE__*/React.createElement("span", {
        className: styles.arrowDown
      }, "\u2193"), "Needed Improvements"), /*#__PURE__*/React.createElement("ul", {
        className: styles.sectionList
      }, !!missingFormatted.length && missingFormatted.map(function (item) {
        return /*#__PURE__*/React.createElement("li", {
          className: styles.minusItem
        }, item);
      })))))), /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Your Facebook Checklist"), template && !!template.sections.length && template.sections.map(function (section, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "".concat(section.key, "_preview_").concat(index),
          className: styles.previewRow
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(styles.checkArea, " ").concat(styles["check".concat(template.checklistOptions[parseInt(section.value, 10)].key)])
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.check
        }), /*#__PURE__*/React.createElement("span", {
          className: styles.checkAreaText
        }, template.checklistOptions[parseInt(section.value, 10)].label.replace('<br/>', '\n'))), /*#__PURE__*/React.createElement("div", {
          className: styles.stepDetails
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.stepDetailsTitle
        }, "".concat(index + 1, ". ").concat(section.label)), (section.key === 'cover' || section.key === 'picture') && section.dataValue ? /*#__PURE__*/React.createElement("div", {
          className: styles.stepDetailsData
        }, /*#__PURE__*/React.createElement("img", {
          src: section.dataValue,
          style: {
            maxHeight: 150
          }
        })) : /*#__PURE__*/React.createElement("div", {
          className: styles.stepDetailsData
        }, section.dataValue), section.value === 3 && section.feedback && /*#__PURE__*/React.createElement("div", {
          className: styles.stepDetailsFeedback
        }, "Feedback: ", section.feedback), section.comments && /*#__PURE__*/React.createElement("div", {
          className: styles.stepDetailsFeedback
        }, "Comments: ", section.comments)), /*#__PURE__*/React.createElement("div", {
          className: styles.metaData
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.metaDataItem
        }, "Checked: ", section.updatedAt ? section.updatedAt : ''), _this2.props.partnerTheme && parseInt(_this2.props.partnerTheme.OrganizationId, 10) === 0 && /*#__PURE__*/React.createElement("span", {
          className: styles.metaDataItem,
          style: {
            paddingTop: 12
          }
        }, "Inspected By:", ' ', section.inspectedBy ? "".concat(section.inspectedBy.firstName, " ").concat(section.inspectedBy.lastName) : '')));
      }));
    }
  }]);

  return FacebookChecklistPreview;
}(Component)) || _class);
export { FacebookChecklistPreview as default };